import { useParams } from "react-router-dom";
import { useIntegrations } from "./useIntegrations";

export const useSlugIntegration = () => {
   const { integrations, handleFetchIntegrations } = useIntegrations();
   const params = useParams();

   return {
      integration: integrations.find((integration) => integration.id === params.slug),
      handleFetchIntegrations
   };
};
